import styled from 'styled-components/macro';

const Button = styled.button`
  font-size: 16px;
  line-height:20px;
  font-family: var(--sv-font-sans);
  font-weight: 600;
  padding: 11px 16px;
  transition: 0.5s all ease-out;
  border-radius: 999px;

  &:enabled {
    color: var(--sv-color-dark-green);
    background: var(--sv-color-white);
    border: 1px solid var(--sv-color-dark-green);
    cursor: pointer;
  }
 
  &:enabled:hover {
    color: var(--sv-color-white);
    background: var(--sv-color-dark-green);
    border-color: var(--sv-color-dark-green);
  }

  &:disabled {
    color: var(--sv-color-medium-gray);
    background: var(--sv-color-light-gray);
    border: 1px solid var(--sv-color-medium-gray);
  }
`;

export default Button;
